import { render, staticRenderFns } from "./CspaceShareBtn.vue?vue&type=template&id=8da36ee2&"
import script from "./CspaceShareBtn.vue?vue&type=script&lang=js&"
export * from "./CspaceShareBtn.vue?vue&type=script&lang=js&"
import style0 from "./CspaceShareBtn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports